import { useEffect } from 'react';
import { useMap } from '@vis.gl/react-google-maps';
import { toLatLng, panTo, calcZoom } from "utils/map";

const MapHandler = ({
    region,
    animateTS,
    animationDuration,
    selectedRouteData,
    mapReady,
    setMapInstance,
    setMapReady,
    prevAnimationTS,
    setPrevAnimationTS,
    prevSelectedRouteSlug,
    setPrevSelectedRouteSlug
}) => {
    const map = useMap();

    // Set the map instance when the map is loaded
    useEffect(() => {
        if (map && !mapReady) {
            setMapInstance(map);
            setMapReady(true);
        }
    }, [map, mapReady, setMapInstance, setMapReady]);

    // Handle region/camera changes
    useEffect(() => {
        if (mapReady && map && region && animateTS > prevAnimationTS) {
            setPrevAnimationTS(animateTS);

            // if it's a new route, don't animate, just jump to the new region
            if (selectedRouteData && selectedRouteData.slug !== prevSelectedRouteSlug) {
                setPrevSelectedRouteSlug(selectedRouteData.slug);
                map.setZoom(calcZoom(region));
                map.setCenter(toLatLng(region));
            } else {
                panTo(map, toLatLng(region), animationDuration);
            }
        }
    }, [
        prevAnimationTS,
        animateTS,
        animationDuration,
        region,
        map,
        mapReady,
        selectedRouteData,
        prevSelectedRouteSlug,
        setPrevAnimationTS,
        setPrevSelectedRouteSlug
    ]);

    return null;
};

export default MapHandler;
